<template>
  <div class="product-downloads product-videos">
    <input type="hidden" name="downloads" v-model="downloadsImploded" />

    <div class="loading"
         v-show="loading">
      <div class="fa-3x">
        <i class="fas fa-spinner fa-pulse"></i>
      </div>
    </div>
    <input type="file"
           style="display: none"
           name="newFile"
           id="newFile"
           v-on:change="addFile($event)"
    />

    <table class="table table-sm">
      <thead>
        <tr>
          <th style="width: 30px">#</th>
          <th>Name</th>
          <th>Link</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(download, index) in downloads">
          <td>
            {{ index + 1 }}
          </td>
          <td>
            <input type="text" class="form-control" v-model="download.name" />
          </td>
          <td>
            <input type="url" class="form-control" v-model="download.link" placeholder="Insert link URL" />
            or
            <label class="button button-primary-outline btn-sm btn-block" for="newFile" @click="startUpload(index)">
              <ion-icon name="add-circle"></ion-icon>
              Upload file
            </label>
          </td>
          <td>
            <div class="actions">
              <button class="btn btn-sm btn-danger action"
                      type="button"
                      @click="remove(index)">
                <ion-icon name="remove-circle-outline"></ion-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4">
            <button class="btn btn-success"
                    type="button"
                    @click="add">
              Add download
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "ProductDownloads",
  props: ['product'],
  data(){
    return {
      loading: false,
      uploadingFileIndex: -1,
      downloads: []
    }
  },
  mounted() {
    setTimeout(() => {
      this.downloads = JSON.parse(JSON.stringify(this.product.downloads || []))
    }, 50)
  },
  methods: {
    startUpload(index) {
      this.uploadingFileIndex = index
    },
    addFile(event) {
      let file = event.target.files[0];

      if (!file) {
        return
      }

      this.uploadToServer(file)
    },
    uploadToServer(file) {
      let formData = new FormData();
      formData.append('file', file)
      this.loading = true

      axios.post('/products/upload_file',
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then((r) => {
        this.downloads[this.uploadingFileIndex].link = r.data.link
        this.uploadingFileIndex = -1
        $('#downloadsImploded')[0].file = null
        $('#downloadsImploded').val(null)

      }).finally(() => {
        this.loading = false
      })
    },
    add() {
      this.downloads.push({
        "link": '',
        "name": '',
      })
    },
    remove(index) {
      let video = this.downloads[index]

      if (!video.link) {
        return this.downloads.splice(index, 1)
      }

      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this video?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.downloads.splice(index, 1)
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    },
  },
  computed: {
    downloadsImploded(){
      return JSON.stringify(this.downloads)
    }
  }
}
</script>

<style scoped>

</style>
